import AuthLayout from '@/layouts/AuthLayout';
import MainLayout from '@/layouts/MainLayout';
import Loading from '@/pages/Loading';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './guards/ProtectedRoute';
import PublicRoute from './guards/PublicRoute';

const AcceptInvite = lazy(() => import('@/pages/AcceptInvite'));
const FacilityBids = lazy(() => import('@/pages/FacilityBids'));
const Insights = lazy(() => import('@/pages/Insights'));
const Login = lazy(() => import('@/pages/Login'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const Portfolios = lazy(() => import('@/pages/Portfolios'));
const Profile = lazy(() => import('@/pages/Profile'));
const Schedulers = lazy(() => import('@/pages/Schedulers'));
const Settings = lazy(() => import('@/pages/Settings'));

// Note: /authentication/callback and /authentication/silent-callback
// are handled automatically by @axa-fr/react-oidc library

export const routeConfig = [
  { path: '/', element: <Navigate to="/login" replace /> },

  {
    path: '/',
    element: (
      <PublicRoute>
        <AuthLayout />
      </PublicRoute>
    ),
    children: [
      { path: 'login', element: <Login /> },
    ],
  },

  // No auth guard: must be reachable by anyone with a valid invite link,
  // authenticated or not, and must not redirect based on auth state.
  {
    path: '/',
    element: <AuthLayout />,
    children: [{ path: 'invite/accept/:inviteCode', element: <AcceptInvite /> }],
  },

  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/loading" replace /> },
      { path: 'loading', element: <Loading /> },
      { path: 'facility-bids', element: <FacilityBids /> },
      { path: 'insights', element: <Insights /> },
      { path: 'profile', element: <Profile /> },
      { path: 'schedulers', element: <Schedulers /> },
      { path: 'settings', element: <Settings /> },
      { path: 'portfolios', element: <Portfolios /> },
    ],
  },

  { path: '404', element: <NotFound /> },
  { path: '*', element: <NotFound /> },
];
